export default __webpack_public_path__ + "assets/d55d35d0e44004ec1a4a8c9659d67d82.png";